import React from 'react';
import { Row, Col, Card, CampoEstatico, TipoCampoEstatico } from '@intechprev/componentes-web';
import { SimuladorRendaMensalService } from '../../services';
import { SimuladorRendaMensalDatas } from '../../entidades';

interface Props {
  DataNascimento: Date;
  ValorSalario: number;
  SaldoAcomulado: number;
};

interface State {
  Datas: SimuladorRendaMensalDatas;
};

export class Header extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      Datas: new SimuladorRendaMensalDatas()
    };
  }

  componentDidMount = async () => {
    try {
      const Datas = await SimuladorRendaMensalService.BuscarDatas();

      this.setState({
        Datas
      });
    }
    catch (err) {
      console.error(err);
    }
  }

  render() {
    return (
      <>
        <Row>
          <Col tamanho={"md-4"}>
            <Card titulo={"Data de Nascimento"}>
              <span className={"text-info"}>
                {this.props.DataNascimento}
              </span>
            </Card>
          </Col>

          <Col tamanho={"md-4"}>
            <Card titulo={"Idade Atual"}>
              <span className={"text-info"}>
                {this.state.Datas.IDADE_ATUAL}
              </span>
            </Card>
          </Col>

          <Col tamanho={"md-4"}>
            <Card titulo={"Adesão ao Plano"}>
              <span className={"text-info"}>
                {this.state.Datas.DT_INSC_PLANO}
              </span>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col tamanho={"md-4"}>
            <Card titulo={"Tempo de Plano"}>
              <span className={"text-warning"}>
                {this.state.Datas.TEMPO_VINC_PLANO}
              </span>
            </Card>
          </Col>

          <Col tamanho={"md-4"}>
            <Card titulo={"Salário de Participação"}>
              <span className={"text-success"}>
                <CampoEstatico
                  valor={this.props.ValorSalario}
                  tipo={TipoCampoEstatico.dinheiro}
                />
              </span>
            </Card>
          </Col>

          <Col tamanho={"md-4"}>
            <Card titulo={"Saldo Acumulado Total"}>
              <span className={"text-warning"}>
                <CampoEstatico
                  valor={this.props.SaldoAcomulado}
                  tipo={TipoCampoEstatico.dinheiro}
                />
              </span>
            </Card>
          </Col>
        </Row>
      </>
    );
  }
}